import momentCore from 'moment';
import { extendMoment } from 'moment-range';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const moment = extendMoment(momentCore);

const maxPossibleTimestamp = 8.64e15;
export const maxMomentDate = moment(maxPossibleTimestamp);
